import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

const languages = ["vi", "en"];

i18n.use(Backend).use(initReactI18next).init({
    lng: "vi",
    fallbackLng: "en",
    saveMissing: false,
    debug: false,
    whitelist: languages,
    backend: {
        loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
    },
});
export default i18n;
